/* jshint esnext: true */
/**
 * dropdown category
 ***********************/
$(document).ready(function() {
  var
    active = 'js-active',
    $tabContents = $('.tab__contents > div'),
    $tabMenu = $('.tab__menu > li');

  $tabMenu.click(function() {
    var idx = $(this).data('index');

    $tabMenu.removeClass(active);
    $(this).addClass(active);

    $tabContents
      .removeClass(active)
      .filter('[data-index="' + idx + '"]')
      .addClass(active);
  });
});
